import React, { useState,useEffect } from 'react';
import USBModal, { ModalHeader, ModalBody, ModalFooter } from '@usb-shield/react-modal';
import USBButton from '@usb-shield/react-button';
import USBNotification from "@usb-shield/react-notification";
import { useStore } from '../store/index';
import parse from 'html-react-parser';
import USBEmailInput from "@usb-shield/react-forms-input-email";
import {sendPrivacyOptOut} from '../services/privacyOptOut';
import { setCookie, getCookie } from '../utils/privacyChoices';
import {
  // CLOSE_MODAL_LABEL,
  // PRIVACY_OPTOUT,
  PRIVACY_OPT_EMAIL_INPUT,
  PRIVACY_EMAIL_INPUT_LABEL,
  PRIVACY_OPT_SUCCESS_MSG,
  PRIVACY_OPT_MSG_CONFIRMATION,
  // labelledBy,
  // describedBy,
  cookieName,
  PRIVACY_OPT_ERROR_MSG,
  PRIVACY_OPT_ERROR_MSG_CONFIRMATION,
  PRIVACY_OPT_ERROR_MSG_INVALID_EMAIL,
  ELAVON_COOKIE_DOMAIN,
  OPT_OUT_SUCCESS,
} from "../constants/index";

// import '../../styles/custom-modal.css';

interface YourPrivacyChoicesComponentProps {
  isOpen: boolean;
  onClose: () => void;
  
}

const YourPrivacyChoicesComponent: React.FC<YourPrivacyChoicesComponentProps> = ({ isOpen, onClose }) => {
  const { aemContent, setEmailValue, emailValue } = useStore();
  const content = aemContent?.YourPrivacyChoices || {};
  const [notification, setNotification] = useState({
    response: "",
    status: "",
  });
   useEffect(() => {
    const ESCAPE_KEY = 27;
    interface KeyUpEvent extends KeyboardEvent {
      keyCode: number;
    }

    const listener = (e: KeyUpEvent) => {
      if (e.keyCode === ESCAPE_KEY) onClose();
    };
    document.addEventListener("keyup", listener);
    return () => {
      document.removeEventListener("keyup", listener);
    };
  }, []);

  useEffect(() => {
    const optOutCookieVal = getCookie(cookieName);
    if (optOutCookieVal === "1") {
      setNotification({
        response: PRIVACY_OPT_SUCCESS_MSG,
        status: PRIVACY_OPT_MSG_CONFIRMATION,
      });
    } else {
      setNotification({ response: "", status: "" });
    }
    setEmailValue("" );
  }, [isOpen]);

  const handleSubmitApply = async () => {
    setCookie(
      cookieName,
      "1",
      576000,
      "/",
      import.meta.env.MODE !== "local" ? ELAVON_COOKIE_DOMAIN : ""
    );
    if (emailValue) {
      const isEmailValid = emailValue?.match(
        /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
      );
      if (!isEmailValid) {
        setNotification({
          response: PRIVACY_OPT_ERROR_MSG_INVALID_EMAIL,
          status: PRIVACY_OPT_ERROR_MSG_CONFIRMATION,
        });
        return;
      } else {
       
        const response = await sendPrivacyOptOut();
        if (response?.status === OPT_OUT_SUCCESS) {
          setCookie(cookieName, "1", 576000, "/", ELAVON_COOKIE_DOMAIN);
          setNotification({
            response: PRIVACY_OPT_SUCCESS_MSG,
            status: PRIVACY_OPT_MSG_CONFIRMATION,
          });
        } else {
          setNotification({
            response: PRIVACY_OPT_ERROR_MSG,
            status: PRIVACY_OPT_ERROR_MSG_CONFIRMATION,
          });
        }
      }
      setEmailValue("");
      return;
    } else {
      const optOutCookieVal = getCookie(cookieName);
      if (optOutCookieVal === "1") {
        setNotification({
          response: PRIVACY_OPT_SUCCESS_MSG,
          status: PRIVACY_OPT_MSG_CONFIRMATION,
        });
      }
      return;
    }
  };
  const hasLinks = content.modalLinks && content.modalLinks.length > 0;

  // Map notification.status to USBNotification status type
  const getNotificationStatus = (status: string): "success" | "danger" | "caution" | "info" | undefined => {
    switch (status) {
      case PRIVACY_OPT_MSG_CONFIRMATION:
        return "success";
      case PRIVACY_OPT_ERROR_MSG_CONFIRMATION:
        return "danger";
      default:
        return undefined;
    }
  };

  return (
    <USBModal
      isOpen={isOpen}
      handleClose={onClose}
      id="your-privacy-modal"
      className="!overflow-visible !max-h-none !h-auto !min-h-0"
    >
      <ModalHeader id="your-privacy-modal-header">
        <span
          className="text-[20px] font-medium"
          style={{ color: 'var(--label-vivid, #2E2E32)' }}
        >
          {content.title}
        </span>
      </ModalHeader>
      {notification.response && notification.response != "" && (
          <USBNotification
            status={getNotificationStatus(notification.status)}
            id="opt-out-notification"
            addClasses={"banker-app-widget relative notification-banner-custom px-8"}
            iconAssistiveText={{
              label: "opt-out-notification",
            }}
          >
            <button
              type="button"
              aria-label="Close notification"
              className="absolute top-2 right-2 w-7 h-7 flex items-center"
              onClick={() => setNotification({ response: "", status: "" })}
            >
              <span className="w-5 h-5 flex items-center justify-center rounded-full border border-2">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" className="w-3.5 h-3.5">
                  <line x1="5" y1="5" x2="15" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  <line x1="15" y1="5" x2="5" y2="15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </span>
            </button>
            <p className="notification-header pr-6">{notification.response}</p>
          </USBNotification>
        )}
      <ModalBody>
        <div className="text-[#4C4C50] flex flex-col !overflow-visible !max-h-none !h-auto">
          {/* Render description as a whole, do not split or skip paragraphs regardless of notification */}
          <div className="[&>p]:mb-6 text-[#4C4C50]">
            {parse(content.description || '')}
          </div>
          <USBEmailInput
              inputName={PRIVACY_OPT_EMAIL_INPUT}
              labelText={PRIVACY_EMAIL_INPUT_LABEL}
              dynamicValue={emailValue}
              callbackFrequency="every"
              statusUpdateCallback={(e: { inputValue: string }) => setEmailValue(e.inputValue)}                
              maxLength={254}
              className="custom-email-label-input"
              />
            <span className="text-xs text-gray-400 mt-1 mb-6">Optional</span>
          <div className="mb-1 mt-1">
            {/* Render note as a single line, but keep spacing */}
            <span className="text-[#4C4C50]">
              {(() => {
                if (!content.note) return null;
                const match = content.note.match(/<strong>(.*?)<\/strong>\s*<p>(.*?)<\/p>/i);
                if (match) {
                  return <span><strong>{match[1]}</strong> {match[2]}</span>;
                }
                return parse(content.note.replace(/<[^>]{0,250}?>/g, ' '));
              })()}
            </span>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="w-full flex justify-between items-center flex-col-reverse md:flex-row gap-6">
          {hasLinks ? (
            content.modalLinks.map((item: any, index: number) => (
              <React.Fragment key={`modal-link-${index}-${item?.title}`}>
                <a
                  href={item?.url}
                  target={item?.target}
                  rel="noopener noreferrer"
                  className="text-blue-700 font-bold hover:underline md:pl-6"
                >
                  {item?.title}
                </a>
                {index < content.modalLinks.length - 1 && <div className="border-r border-gray-800 mx-2 h-4" />}
              </React.Fragment>
            ))
          ) : (
            <span className="text-blue-700 text-sm font-bold">
              {content?.modalLinks?.length > 0 ? content.modalLinks[0].title : "Learn more about privacy choices"}
            </span>
          )}
          <USBButton ctaStyle="standard" emphasis="heavy" addClasses='w-full md:w-fit' handleClick={handleSubmitApply}>
            {content?.button?.accept?.text || "Opt Out"}
          </USBButton>
        </div>
      </ModalFooter>
    </USBModal>
  );
};

export default YourPrivacyChoicesComponent;

